// Single source of truth for "which homepage-style section anchors
// (#transformations, #faq, #pricing, #process, #about) actually exist on
// the current page." Used by both Navbar.jsx and Footer.jsx so a nav/footer
// link never silently does nothing just because the current page doesn't
// happen to include that section.
//
// Verified against the actual prerendered output (not assumed) for every
// route type on the site as of this writing:
//   /                    → transformations, faq, pricing, process, about, inquiry
//   /campaigns/*         → transformations, faq, inquiry (reuse those components)
//   /partner             → faq only
//   /insights, /insights/:slug, /onlinegrowth → none of these sections
//
// If a future page reuses one of these homepage sections directly, add its
// path prefix to the relevant array below — that's the only change needed;
// both Navbar and Footer read from this automatically.
const SECTION_AVAILABILITY = {
  transformations: ['/campaigns/'],
  faq: ['/campaigns/', '/partner'],
  inquiry: ['/campaigns/'],
  // pricing, process, about: homepage only — nothing else needed here.
}

function sectionExistsOnPage(anchorId, pathname) {
  if (pathname === '/') return true
  const prefixes = SECTION_AVAILABILITY[anchorId] || []
  return prefixes.some((prefix) => pathname.startsWith(prefix))
}

/**
 * Resolves a "#anchorId" href against the current pathname. If the anchor
 * exists on the current page, returns the bare hash (stays on page,
 * scrolls). Otherwise returns "/#anchorId" (navigates home first, then
 * scrolls) instead of a link that would silently do nothing.
 */
export function resolveSectionHref(anchorId, pathname) {
  return sectionExistsOnPage(anchorId, pathname) ? `#${anchorId}` : `/#${anchorId}`
}
